import dev from "./dev";
import pro from "./pro";
import local from "./local";
import sim from "./sim";

export default env=>{
    switch(env){
        case "production": //生产环境
            pro();
            break;
        case "development": //测试环境
            dev();
            break;
        case "simulation": //仿生产环境
            sim();
            break;
        default: //本地环境
            local();
    };
}